<template>
  <div class="main">
    <div class="mark" v-if="showDetails" @click="hideMark">
      <div class="box" @click.stop>
        <div class="postDetailsTop">
          <img :src="postDetailsData.userAvatarUrl" alt="">
          <span>{{postDetailsData.userName}}</span>
          <p><img @click="delPost(postDetailsData.id)" v-show="currentUserId == postDetailsData.userId" style="width: 30px; height: 30px; cursor: pointer;" src="../../../static/image/delete.png" alt=""></p>
        </div>
        <div class="swipe">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in postDetailsData.userPostImages" :key = "index">
              <div class="swiper-zoom-container">
                <img :class="{imageHeight: item.height >= item.width, imageWidth: item.height < item.width}" :src="item.url" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="description">
          {{postDetailsData.content}}
        </div>
      </div>
    </div>
    <div class="addMark" v-if="showSubmit" @click="hideSubmit">
      <div class="box" @click.stop>
        <textarea placeholder="分享新动态....." class="input" v-model="messages"></textarea>
        <van-uploader :after-read="afterRead" multiple v-model="fileList" preview-size="80"
                      :max-count="9" :before-delete="deleteImage"/>
        <div class="button" @click="submit">提交</div>
      </div>
    </div>
    <header>
      <div class="logout" id="logout" v-show="showLogin" @mouseleave="hideLogin" @mouseenter="showLoginMark">
        <li v-show="!token" style="cursor: pointer" @click="toLoginPage">登录</li>
        <li v-show="token" style="cursor: pointer" @click="logout">退出登录</li>
      </div>
      <div class="top">
        <div class="login" style="border-radius: 0">
          <img @click="toHomePage" style="border-radius: 0; cursor: pointer;" src="../../../static/image/logo.png" alt="">
        </div>
        <div class="addPost" @click="submitPost">
          发布</div>
        <div class="login" @mouseleave="hideLogin" @mouseenter="showLoginMark">
          <img :src="avatarUrl" alt="">
          {{displayName}}
        </div>
      </div>
    </header>
    <main>
      <div class="content">
        <vue-data-loading
          @infinite-scroll="infiniteScroll">
          <div>
            <ul>
              <li style="cursor: pointer" class="shadow" v-for="(item, index) in postList" :key="index" @click="showDetailsData(item.id)">
                <div class="img">
                  <img :src="item.postImages[0].url" :class="{imageHeight: item.postImages[0].height>= item.postImages[0].width, imageWidth: item.postImages[0].height < item.postImages[0].width,}"/>
                </div>
                <div class="main_content">
                  <span class="title">{{item.content}}</span>
                  <div class="liBottom">
                    <div class="liBottom-content">
                      <span><img :src="item.userAvatarUrl" alt=""> {{item.userName}}</span>
                      <span> <img src="../../../static/image/heart.png" alt=""> {{item.numOfLike}}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </vue-data-loading>

      </div>
    </main>
    <FooterBottom v-show="postList.length > 0"></FooterBottom>
  </div>
</template>

<script>
	import FooterBottom from '../common/footer';
	import message from '../js/message';
	import VueDataLoading from 'vue-data-loading';
	export default {
		inject: ['reload'],
		name: "productPage",
		components: {
			VueDataLoading,
			FooterBottom
		},

		data() {
			return {
				showSubmit: false,
				isDisabledSubmit: false,
				fileList: [],
				productValue: 5,
				showDetails: false,
        postId: "",
				swiperOption: {
					loop: true,
					initialSlide: 0,
					pagination: {
						el: '.swiper-pagination',
						paginationType: 'bullets'
					},
				},
				name: "",
				showLogin: false,
				avatarUrl: "",
				currentUserId: localStorage.getItem('currentUserId'),
				displayName: localStorage.getItem('name'),
				token: localStorage.getItem('token'),
        pageNum: 1,
        pageSize: 20,
        postList: [],
        postDetailsData: {},
        images: [],
        messages: "",
				messageLength: 1,
				userTypeId: localStorage.getItem('userTypeId'),
			}
		},
		beforeRouteEnter(to, from, next){
			next(vm => {
				if(from.name == 'loginPage'){
					vm.$router.go(0);
				}
			})
		},
		created() {
			this.messageLength = this.userTypeId == 7 ? 6000 : 3000;
			this.avatarUrl = localStorage.getItem('avatarUrl') || require('../../../static/image/header.jpg');
			this.getData();
		},
		mounted(){
			let logout = document.getElementById('logout');
			logout.style.right = (document.body.clientWidth-1220)/2 + 'px';
		},
		methods: {
			infiniteScroll() {
				//到底触发的事件
				this.pageNum ++;
				this.getData();
			},
			//用户删除动态
			delPost(id) {
        this.$store.dispatch('deleteUserPost', id).then((res) => {
          if (res.data.code == 200) {
            this.showDetails = false;
						this.reload();
          }
        })
			},
			submitPost(){
				if(localStorage.getItem("token")){
					this.showSubmit = true;
        }else {
					this.$router.push({
            name: 'loginPage'
          })
        }
      },
			hideSubmit(){
				this.showSubmit = false;
      },
			//计算字符长度
			computedStrLen(str) {
				var len = 0;
				for (var i = 0; i < str.length; i++) {
					var c = str.charCodeAt(i);
					//单字节加1
					if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
						len++;
					} else {
						len += 2;
					}
				}
				return len;
			},
			submit() {
				if (this.messages.trim().length == 0 || this.images.length == 0) {
					this.$message.error(message.messageAndImageEmpty)
				}else if(this.computedStrLen(this.messages) > this.messageLength) {
					this.$message.error(message.messageTooLong)
				} else {
					if (!this.isDisabledSubmit) {
						const loading = this.$loading({
							lock: true,
							text: 'Loading',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						this.isDisabledSubmit = true;
						let formData = new FormData();
						let i = 0;
						this.images.forEach((file) => {
							formData.append('file' + i++, file.file);
						});
						formData.append("content", this.messages);
						this.$store.dispatch("publicationTrends", formData).then((res) => {
							this.isDisabledSubmit = false;
							if (res.data.code == 200) {
								loading.close();
								this.$message.success(message.uploadSuccess);
								this.showSubmit = false
								this.reload();
							} else {
								loading.close();
								this.$message.error(message.uploadFailure)
							}
						})
					}
				}
			},
			//h5 web upload
			afterRead(file) {
				// 此时可以自行将文件上传至服务器
				if (file.length > 1) {
					//vant 多张图file是array
					for (let i = 0; i < file.length; i++) {
						this.images.push(file[i])
					}
				} else {
					//vant 单张图file是object
					this.images.push(file);
				}
			},
			deleteImage(file, detail) {
				return new Promise((resolve, reject) => {
					if (this.images.length > 1) {
						//vant 多张图file是array
						for (let i = 0; i < this.images.length; i++) {
							this.images.splice(detail.index, 1);
						}
					} else {
						//vant 单张图file是object
						this.images = [];
					}
					resolve();
				});
			},
			toLoginPage(){
				this.$router.push({
					name: "loginPage"
				})
			},
			logout(){
				this.avatarUrl = require('../../../static/image/header.jpg');
				this.token = !this.token;
				this.displayName = "";
				localStorage.clear();
				this.$router.push({
					name: "postPage"
				})
			},
			showLoginMark(){
				this.showLogin = true;
			},
			hideLogin(){
				this.showLogin = false;
			},
			toHomePage(){
				this.$router.push({
					path: '/'
				})
			},
      getData(){
				let obj = {
					pageNum: this.pageNum,
          pageSize: this.pageSize
        };
        this.$store.dispatch('findLatestPosts', obj ).then(res => {
        	if(res.data.code == 200){
        		if(res.data.data.list.length == 0){
        			return;
            }
        		if(this.pageNum == 1){
							this.postList = res.data.data.list;
            }else {
							this.postList = this.postList.concat(res.data.data.list);
            }
          }
        })
      },
      getPostDetails(){
				let obj = {
					id: this.postId
        };
				this.$store.dispatch('findUserPostById', obj).then(res => {
					if(res.data.code == 200){
						this.postDetailsData = res.data.data;
          }
        })
      },
			showDetailsData(id){
				this.showDetails = true;
				this.postId = id;
				this.postDetailsData = {};
				this.getPostDetails();
      },
			hideMark(){
				this.showDetails = false;
      }
		}
	}
</script>

<style scoped lang="scss">

  .main {
    .shadow:hover {

      -webkit-box-shadow: #ccc 0px 10px 10px;
      -moz-box-shadow: #ccc 0px 10px 10px;
      box-shadow: #ccc 0px 10px 10px;
      transition-property: all;
      transition-duration: 1s;


    }
    width: 100%;
    .mark{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
      background: rgba(0,0,0,0.5);
      .box{
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        width: 375px;
        height: 667px;
        background: #fff;
        overflow-y: auto;
        overflow-x: hidden;
        .postDetailsTop{
          display: flex;
          height: 70px;
          width: 100%;
          align-items: center;
          justify-content: center;
          img{
            width: 40px;
            height: 40px;
            display: block;
            border-radius: 50%;
            margin-left: 15px;
          }
          span{
            margin-left: 20px;
          }
          p{
            margin-left: auto;
            margin-right: 15px;
          }
        }
        .swipe {
          width: 375px;
          height: 350px;
          .swiper-zoom-container {
            width: 375px;
            height: 350px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              display: block;
            }
            .imageHeight{
              height: 400px;
              width: auto;
            }
            .imageWidth{
              width: 375px;
              height: auto;
            }
          }
        }
        .description{
          margin: 20px 15px;
        }
      }
    }
    .addMark{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
      background: rgba(0,0,0,0.5);
      .box{
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        width: 375px;
        height: 667px;
        background: #fff;
        overflow-y: auto;
        overflow-x: hidden;
        textarea {
          width: 86%;
          margin: 5px 5%;
          height: 350px;
          font-size: 15px;
          border: 0;
          padding: 2%;
          overflow-y: auto;
          resize: none;
          outline: none;
        }
        /deep/ .van-uploader__upload{
          margin: 10px;
        }
        /deep/ .van-uploader__preview-image{
          margin: 10px;
        }

        .button{
          width: 80%;
          height: 50px;
          text-align: center;
          line-height: 50px;
          color: #fff;
          position: absolute;
          bottom: 20px;
          left: 10%;
          background: #b0becb;
          cursor: pointer;
        }
      }
    }

    header {
      width: 100%;
      background: #fff;
      height: 100px;
      position: relative;

      .logout{
        width: 100px;
        height: 50px;
        position: absolute;
        top: 70px;
        border: 1px solid #f2f2f2;
        border-radius: 6px;
        background: #fff;

        li{
          text-align: center;
          line-height: 50px;
        }
      }

      .top {
        height: 100px;
        width: 1220px;
        margin: 0 auto;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .login{
          width: auto;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          img{
            display: block;
            width: 50px;
            height: auto;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
        .addPost{
          width: 100px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          background: #B0BECB;
          font-size: 16px;
          color: #fff;
          cursor: pointer;
          margin-left: 850px;

        }
        .allCategory {
          margin-top: 20px;
          float: right;
          margin-right: 560px;
        }
      }
    }
    .content {
      width: 1220px;
      margin: 0 auto;

      ul {
        display: flex;
        flex-wrap: wrap;

        li {
          width: 25%;
          padding-bottom: 15px;

          .img {
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
            justify-content: center;
            .imageWidth{
              width: 80%;
              height: auto;
            }
            .imageHeight{
              height: 80%;
              width: auto;
            }
            img{
              display: block;
            }
          }

          .main_content {
            width: 90%;
            margin-left: 5%;

            .title {
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
              display: -webkit-box;
              overflow: hidden;
              -webkit-box-orient: vertical;
              font-weight: 500;
              height: 40px;
            }

            .liBottom {
              display: flex;
              align-items: center;
              justify-content: space-around;
              flex-direction: row;
              width: 94%;
              margin-left: 3%;
              margin-top: 20px;
              .liBottom-content{
                width: 100%;
                display: flex;
                span:first-child{
                  display: flex;
                  align-items: center;
                  img{
                    width: 30px;
                    height: 30px;
                    display: block;
                    border-radius: 50%;
                    margin-right: 10px;
                  }

                }
                span:last-child{
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  img{
                    width: 20px;
                    height: 20px;
                    display: block;
                    margin-right: 10px;
                  }

                }
                span{
                  width: 50%;
                  display: block;
                }
              }
            }
          }
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/post/postPage.vue